import React from "react";
import Loading from "components/Loading";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  loading: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translateX(-50%) translateY(-50%)"
  },
  loadingContainer: {
    zIndex: 2,
    position: "absolute",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    // backgroundColor: "gray",
    // opacity: 0.3
  },
}));

export default function MapLoading() {
  const classes = useStyles();

  return (
    <div className={classes.loadingContainer}>
      <div className={classes.loading}>
        <Loading />
      </div>
    </div>
  );
}
